<template>
  <div>
    <!-- <label class="switch">
      <input type="checkbox" @click="popupActive=true" :checked="value == '1'" />
      <span class="slider round"></span>
    </label>-->

    <b-form-checkbox
      @click.native="popupActive = true"
      value="1"
      unchecked-value="0"
      v-model="form.contract_active"
      switch
      class="table-status-icon"
    ></b-form-checkbox>

    <div class="demo-alignment">
      <vs-popup
        :id="'popmodalS' + params.data.employment_id"
        :button-close-hidden="true"
        class="holamundo p-2"
        title="Employee Status"
        :active.sync="popupActive"
      >
        <div class="text-center">
          <h5>Do you want to change Status ?</h5>
          <!-- SUBMIT BUTTON -->
          <div class="vx-row mt-5">
            <div class="vx-col mx-auto">
              <!-- :disabled="submitStatus" -->
              <vs-button
                color="success"
                type="filled"
                @click="onChangeCheckbox($event)"
                class="mr-3"
                >Yes</vs-button
              >

              <vs-button color="danger" type="filled" @click="privStatus()"
                >No</vs-button
              >
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import employeeService from "@/services/employeeService.js";

export default Vue.extend({
  data() {
    return {
      params: null,
      popupActive: false,
      form: {
        contract_active: "1",
      },
      copy_contract_active: null,
    };
  },
  beforeMount() {
    this.form = this.params.data;
    this.copy_contract_active = this.form.contract_active;
  },
  beforeDestroy() {
    let _id = document.getElementById(
      "popmodalS" + this.params.data.employment_id
    );
    _id.setAttribute("style", "display: none;");
  },
  methods: {
    onChangeCheckbox: function(e, value) {
      this.$vs.loading();
      // this.value = this.value === "1" ? "2" : "1";
      let id = this.params.data.employment_id;
      let payload = {
        // employment_name: this.params.data.employment_name,
        // company_id: this.params.data.company_id,
        // description: this.params.data.description,
        ...this.params.data,
        contract_active: this.form.contract_active,
      };
      console.log(payload, "fsdfds");
      employeeService
        .editEmployee(payload, id)
        .then((response) => {
          this.$vs.loading.close();
          const { data } = response;
          if (data.Status == true || data.Status == "true") {
            this.$vs.notify({
              title: "Updated!",
              text: data.Message,

              iconPack: "feather",
              icon: "check_box",
              color: "success",
            });
            this.popupActive = false;
          } else {
            this.$vs.loading.close();
            console.log("data :", data);
            this.privStatus();
            this.$vs.notify({
              title: "Error!",
              text: data.Message,

              iconPack: "feather",
              icon: "check_box",
              color: "warning",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
    privStatus: function() {
      this.popupActive = false;
      this.form.contract_active = this.copy_contract_active;
    },
  },
});
</script>
